import React from 'react';
import { motion } from 'framer-motion';
import { BookIcon, MapPinIcon, ClipboardIcon, MessageIcon, StarIcon } from './Icons';
export function ValueStack() {
  return <section className="w-full bg-beige py-10 md:py-24 px-5" data-id="element-470">
      <div className="max-w-2xl mx-auto" data-id="element-471">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl border-2 border-gold/40 shadow-xl overflow-hidden" data-id="element-472">
          {/* Header */}
          <div className="bg-brown-dark text-white p-6 text-center" data-id="element-473">
            <h2 className="font-heading text-2xl md:text-3xl font-bold mb-2" data-id="element-474">
              Resumen de Todo lo que Recibes
            </h2>
            <p className="font-body text-gold-light text-sm uppercase tracking-widest font-semibold" data-id="element-475">
              Oferta Especial Hoy
            </p>
          </div>

          {/* Table Body */}
          <div className="p-6 md:p-8" data-id="element-476">
            <div className="space-y-4" data-id="element-477">
              {/* Row 1 */}
              <div className="flex items-center justify-between p-4 bg-cream rounded-xl border border-gold/10" data-id="element-478">
                <div className="flex items-center gap-3" data-id="element-479">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-480">
                    <BookIcon className="w-5 h-5 text-gold" data-id="element-481" />
                  </div>
                  <span className="font-body text-base md:text-lg font-semibold text-brown-dark" data-id="element-482">
                    📘 Rescate Capilar 60+{' '}
                    <span className="hidden sm:inline font-normal text-brown-medium" data-id="element-483">
                      (Protocolo principal)
                    </span>
                  </span>
                </div>
                <span className="font-body text-base md:text-lg text-brown-medium whitespace-nowrap ml-4" data-id="element-484">
                  $27 USD
                </span>
              </div>

              {/* Row 2 */}
              <div className="flex items-center justify-between p-4 bg-white rounded-xl border border-gold/10" data-id="element-485">
                <div className="flex items-center gap-3" data-id="element-486">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-487">
                    <MapPinIcon className="w-5 h-5 text-gold" data-id="element-488" />
                  </div>
                  <span className="font-body text-base md:text-lg font-medium text-brown-dark" data-id="element-489">
                    🎁 Bono #1: Mapa Express del Cuero Cabelludo™
                  </span>
                </div>
                <span className="font-body text-base md:text-lg text-brown-medium whitespace-nowrap ml-4" data-id="element-490">
                  $27 USD
                </span>
              </div>

              {/* Row 3 */}
              <div className="flex items-center justify-between p-4 bg-cream rounded-xl border border-gold/10" data-id="element-491">
                <div className="flex items-center gap-3" data-id="element-492">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-493">
                    <ClipboardIcon className="w-5 h-5 text-gold" data-id="element-494" />
                  </div>
                  <span className="font-body text-base md:text-lg font-medium text-brown-dark" data-id="element-495">
                    🎁 Bono #2: Checklist Anti-Irritantes™
                  </span>
                </div>
                <span className="font-body text-base md:text-lg text-brown-medium whitespace-nowrap ml-4" data-id="element-496">
                  $27 USD
                </span>
              </div>

              {/* Row 4 */}
              <div className="flex items-center justify-between p-4 bg-white rounded-xl border border-gold/10" data-id="element-497">
                <div className="flex items-center gap-3" data-id="element-498">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-499">
                    <MessageIcon className="w-5 h-5 text-gold" data-id="element-500" />
                  </div>
                  <span className="font-body text-base md:text-lg font-medium text-brown-dark" data-id="element-501">
                    🎁 Bono #3: Guión de 7 Días "Estoy en Rescate"™
                  </span>
                </div>
                <span className="font-body text-base md:text-lg text-brown-medium whitespace-nowrap ml-4" data-id="element-502">
                  $27 USD
                </span>
              </div>
            </div>

            {/* Totals */}
            <div className="mt-8 pt-6 border-t-2 border-dashed border-gold/30" data-id="element-503">
              <div className="flex items-center justify-between mb-6" data-id="element-504">
                <span className="font-heading text-xl md:text-2xl font-bold text-brown-dark" data-id="element-505">
                  TOTAL REAL
                </span>
                <span className="font-heading text-xl md:text-2xl font-bold text-brown-dark line-through decoration-red-500/50 decoration-2" data-id="element-506">
                  $108 USD
                </span>
              </div>

              <div className="bg-gold/10 rounded-xl p-6 border-2 border-gold flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left" data-id="element-507">
                <div className="flex items-center gap-3" data-id="element-508">
                  <StarIcon className="w-8 h-8 text-gold hidden sm:block" data-id="element-509" />
                  <span className="font-heading text-2xl md:text-3xl font-bold text-brown-dark" data-id="element-510">
                    Tu inversión hoy
                  </span>
                </div>
                <span className="font-heading text-5xl md:text-6xl font-bold text-gold drop-shadow-sm" data-id="element-511">
                  $17 <span className="text-2xl md:text-3xl" data-id="element-512">USD</span>
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}